export type Language = 'ru' | 'en';

export const translations = {
  ru: {
    // Header
    appName: '🏰 TON Farm',
    
    // Treasures Screen
    treasureTrials: 'Treasure Trials',
    faqButton: '❓ FAQ',
    treasureDescription: 'Начни с малого. Проходи сундуки чтобы получать больше профита!',
    canBuyTab: 'Можно купить',
    activeTab: 'В работе',
    buyChestButton: 'Купить сундук',
    noActiveChests: 'Купи сундук!',
    chestOpening: '⏳ Сундук открывается...',
    rewardReady: '✨ Награда готова! Успейте собрать!',
    claimWindowExpires: '⚠️ Окно сбора истекает через:',
    afterExpiryReturn: 'После истечения вернётся только 70% от стоимости',
    rewardOnClaim: 'Награда при сборе:',
    claimRewardButton: '🎁 Собрать награду',
    waitingForOpening: '⏳ Ожидание открытия...',
    readyToClaim: '✅ Готово к сбору!',
    
    // Treasure card labels
    cost: 'Стоимость',
    payout: 'Выплата',
    cycle: 'Цикл',
    allTimeProfit: 'Заработано',
    
    // Chest unlock messages
    chestLocked: '🔒 Заблокирован',
    unlockCondition: 'Получи награду из предыдущего сундука',
    unlockProgress: 'Прогресс разблокировки',
    claimsRemaining: 'Собери награду с предыдущего сундука',
    claimsRemainingFrom: 'Собери награду с', // "Собери награду с Bronze Treasure"
    times: 'раз',
    comingSoonChests: 'НОВЫЕ СУНДУКИ\nСКОРО В НАЛИЧИИ',
    
    // Rules
    rulesButton: '📖 Правила',
    rulesTitle: '📖 Правила игры',
    rulesHowItWorks: '🎁 Как работают сундуки?',
    rulesHowItWorksText: '1. Купи сундук за TON\n2. Дождись открытия (время зависит от сундука)\n3. Собери награду в течение 8 часов\n4. Получи TON + профит!',
    rulesUnlocking: '🔓 Разблокировка сундуков',
    rulesUnlockingText: 'Условия разблокировки указаны на карточке каждого сундука. Прогресс разблокировки показан прямо на карточке.',
    rulesBurning: '🔥 МЕХАНИКА СЖИГАНИЯ',
    rulesBurningText: 'После открытия сундука у тебя есть 8 ЧАСОВ на сбор награды!\n\n⚠️ Если не успеешь:\n• Получишь только 70% от стоимости сундука\n• 30% от стоимости + ВЕСЬ ПРОФИТ сгорят безвозвратно\n\n✅ Собирай вовремя - получай 100% (стоимость + профит)!',
    rulesImportant: '⚡ Важно знать',
    rulesImportantText: '• Время открытия можно сократить бонусами\n• Следи за таймером истечения\n• Награды начисляются мгновенно',
    rulesClose: 'Закрыть',
    
    // FAQ
    faqTitle: '❓ FAQ',
    faqAccountRules: '📛 Правила аккаунта',
    faqAccountText: 'Создание или использование нескольких аккаунтов строго запрещено.\nДля нас важна честность игроков. Любые попытки манипуляции будут караться перманентным баном без восстановления.',
    faqWithdrawal: '💸 Вывод средств',
    faqWithdrawalText: 'Вывод доступен через 24 часа после пополнения.\nВсе выводы в TON обрабатываются в течение 24 часов.\nОбычно быстрее, но допускается до одного дня.',
    faqDisclaimer: '🎮 Дисклеймер игры',
    faqDisclaimerText: 'Это игра. Все взносы являются добровольными пожертвованиями.\nМы не предоставляем финансовые или инвестиционные услуги.',
    faqClose: 'Закрыть',
    
    // Balance Screen
    balanceTitle: '💰 Баланс',
    supportButton: 'Поддержка',
    availableBalance: 'Доступно',
    depositButton: '💳 Пополнить',
    withdrawButton: '💸 Вывести',
    transactionHistory: '📜 История транзакций',
    noTransactions: 'История пуста',
    deposit: 'Пополнение',
    withdrawal: 'Вывод',
    referralBonus: 'Реферальный бонус',
    claimReward: 'Награда',
    depositTitle: '💳 Пополнение баланса',
    depositDescription: 'Пополни баланс через TON Connect',
    depositAmount: 'Сумма пополнения',
    minDeposit: 'Минимум 0.5 TON',
    connectWallet: 'Подключить кошелек',
    confirmDeposit: 'Подтвердить пополнение',
    depositSuccess: 'Заявка на пополнение отправлена! Ожидайте подтверждения.',
    withdrawTitle: '💸 Вывод средств',
    withdrawDescription: 'Выведи заработанные TON на свой кошелек',
    withdrawAmount: 'Сумма вывода',
    minWithdraw: 'Минимум 1 TON',
    walletAddress: 'Адрес TON кошелька',
    withdrawFee: 'Комиссия',
    youReceive: 'Вы получите',
    confirmWithdraw: 'Подтвердить вывод',
    withdrawSuccess: 'Заявка на вывод создана!',
    disconnectWallet: 'Отключить кошелек',
    myWallet: 'Мой кошелек',
    status: 'Статус',
    pending: 'Ожидание',
    completed: 'Завершено',
    rejected: 'Отклонено',
    date: 'Дата',
    
    // Friends Screen
    ambassadorProgram: '👑 Амбассадорская программа',
    ambassadorText: 'Есть канал с активной аудиторией? Стань нашим амбассадором и получай эксклюзивные бонусы.',
    becomePartner: '🌟 Стать партнёром',
    inviteFriends: '👥 Пригласи друзей',
    yourReferralLink: 'Твоя реферальная ссылка:',
    copyButton: '📋 Копировать',
    copiedButton: '✅ Скопировано!',
    shareButton: '📤 Поделиться',
    yourStats: '📊 Твоя статистика',
    totalReferrals: 'Всего рефералов',
    totalEarned: 'Заработано',
    byLevels: '📈 По уровням',
    level: 'Уровень',
    referralsCount: 'Рефералов:',
    earned: 'Заработано:',
    yourReferrals: '👤 Твои рефералы',
    referralsLabel: 'Рефералы:',
    deposits: 'Купили:',
    earnedLabel: 'Заработал:',
    noReferrals: 'У тебя пока нет рефералов',
    noReferralsText: 'Поделись своей ссылкой с друзьями и начни зарабатывать!',
    howItWorks: '💡 Как это работает?',
    level1: 'Уровень 1 - 7%',
    level1Text: 'Получай 7% от каждого пополнения баланса твоими прямыми рефералами',
    level2: 'Уровень 2 - 4%',
    level2Text: 'Получай 4% от пополнений баланса рефералами твоих рефералов',
    level3: 'Уровень 3 - 2%',
    level3Text: 'Получай 2% от пополнений баланса рефералами 3-го уровня',
    bonusInfo: '💰 Все бонусы начисляются автоматически на твой баланс!',
    
    // Bottom Nav
    treasures: 'Сундуки',
    balance: 'Баланс',
    friends: 'Друзья',
    games: 'Игры',
    admin: 'Админ',
    
    // Games Screen
    gamesTitle: '🎮 Игры',
    comingSoon: 'Скоро...',
    chooseGame: 'Выбери игру и испытай удачу!',
    game1to100: '1 to 100',
    game1to100Desc: 'Угадай куда выпадет число от 1 до 100. Простая и быстрая игра!',
    gameMines: 'MINES',
    gameMinesDesc: 'Открывай клетки и избегай мин. Забирай выигрыш когда захочешь!',
    minBet: 'Мин. ставка',
    houseEdge: 'House edge',
    gamesInfo: 'ℹ️ Информация',
    gamesInfoFair: 'Все игры с честной генерацией результатов',
    gamesInfoInstant: 'Выигрыши зачисляются мгновенно',
    gamesInfoMinBet: 'Минимальная ставка: 0.1 TON',
    gamesInfoHouseEdge: 'House edge: 2% (сбор с каждой ставки)',
    gamesInfoDailyLimit: 'Лимит: 10 игр в сутки',
    
    // Dice Game
    diceGuessNumber: 'Угадай куда выпадет число',
    diceBetAmount: 'Ставка (TON)',
    diceChooseType: 'Выбери тип',
    diceTargetNumber: 'Целевое число',
    diceMultiplier: 'Множитель',
    diceWinChance: 'Шанс выигрыша',
    diceRolling: 'Бросаем...',
    diceRoll: 'БРОСИТЬ',
    diceWin: 'ВЫИГРЫШ!',
    diceLoss: 'ПРОИГРЫШ',
    diceResult: 'Выпало',
    diceTarget: 'Цель',
    diceHowToPlay: 'Как играть?',
    diceStep1: 'Выбери тип ставки: UNDER (меньше) или OVER (больше)',
    diceStep2: 'Установи целевое число от 2 до 98',
    diceStep3: 'Укажи размер ставки',
    diceStep4: 'Если выпадет число по твоему прогнозу - выигрыш!',
    diceStep5: 'Чем меньше шанс - тем больше множитель',
    minBetError: 'Минимальная ставка 0.1 TON',
    maxBetError: 'Максимальная ставка 10 TON',
    insufficientFunds: 'Недостаточно средств',
    gameError: 'Ошибка при игре',
    
    // Mines Game
    minesBetAmount: 'Ставка (TON)',
    minesCount: 'Количество мин',
    minesStartGame: 'Начать игру',
    minesCashout: 'Собрать выигрыш',
    minesMultiplier: 'Множитель',
    minesPotentialWin: 'Потенциальный выигрыш',
    minesWin: 'ВЫИГРЫШ!',
    minesExplosion: 'ВЗРЫВ!',
    minesHowToPlay: 'Как играть?',
    minesStep1: 'Выбери количество мин (7, 10 или 15)',
    minesStep2: 'Сделай ставку и начни игру',
    minesStep3: 'Открывай безопасные клетки',
    minesStep4: 'Каждая безопасная клетка увеличивает множитель',
    minesStep5: 'Забери выигрыш в любой момент или продолжай',
    minesRisk: 'Чем больше мин - тем выше риск, но и выигрыш огромнее!',
    createGameError: 'Ошибка при создании игры',
    revealError: 'Ошибка при открытии клетки',
    cashoutError: 'Ошибка при выводе',
    
    // Admin Screen
    adminPanel: '🔧 Админ панель',
    statistics: '📊 Статистика',
    withdrawals: '💸 Выводы',
    depositsTab: '💵 Депозиты',
    totalUsers: 'Всего пользователей',
    totalDeposits: 'Всего депозитов',
    totalWithdrawals: 'Всего выводов',
    totalReferralBonuses: 'Всего реф. бонусов',
    pendingWithdrawals: 'Заявки на вывод',
    noPendingWithdrawals: 'Нет заявок',
    user: 'Пользователь',
    amount: 'Сумма',
    fee: 'Комиссия',
    toReceive: 'К получению',
    wallet: 'Кошелек',
    created: 'Создано',
    approve: 'Подтвердить',
    reject: 'Отклонить',
    pendingDeposits: 'Заявки на пополнение',
    noPendingDeposits: 'Нет заявок',
    userWallet: 'Кошелек пользователя',
    
    // Stake Screen
    stakeTitle: '💎 Stake',
    stakeDescription: 'Зарабатывай 2% в день в течение 50 дней. ⚠️ Собирай награды вовремя - иначе получишь только 70% суточной прибыли!',
    stakeLockedMessage: 'Доступно после разблокировки Silver Treasure',
    activeStake: '🔒 Активный Stake',
    stakeUnlocked: '🎉 Stake разблокирован!',
    stakedAmount: 'Сумма стейка:',
    dailyRate: 'Дневная ставка:',
    daysRemaining: 'Дней до разблокировки:',
    pendingRewards: 'Накопленные награды:',
    claimButton: 'Собрать награды',
    claimAvailableIn: 'Сбор доступен через:',
    hours: 'ч',
    days: 'дн.',
    canClaimOncePerDay: 'Можно собирать раз в сутки',
    principalReturned: '💰 Основная сумма вернётся при сборе наград!',
    createNewStake: 'Создать новый Stake',
    orIncreaseStake: 'или увеличить текущий',
    amountLabel: 'Сумма (TON)',
    minimumStake: 'Минимум: 0.7 TON',
    lockPeriod: 'Срок блокировки: 50 дней',
    dailyReturn: 'Дневной возврат: 2%',
    totalReturn: 'Общий возврат: депозит + 100% прибыли',
    claimAnytime: 'Собирай награды каждый день!',
    createStakeButton: 'Создать Stake',
    increaseStakeButton: 'Увеличить Stake',
    stakeCreated: 'Stake создан успешно!',
    stakeIncreased: 'Stake увеличен успешно!',
    howItWorksStake: 'ℹ️ Как это работает',
    howItWorksText1: '1. Заблокируй TON на 50 дней',
    howItWorksText2: '2. Зарабатывай 2% ежедневно',
    howItWorksText3: '3. Собирай награды каждый день',
    howItWorksText4: '4. Получи основную сумму обратно через 50 дней',
    howItWorksText5: '⚠️ МЕХАНИКА СЖИГАНИЯ ДЛЯ STAKE: Если не собрать ежедневную награду вовремя, автоматически поступит только 70% от суточной прибыли (30% сгорит)',
    burnWarningTitle: 'ВНИМАНИЕ! СЖИГАНИЕ!',
    burnWarningText: 'Осталось мало времени до сжигания!',
    burnWarningInfo: 'Если не собрать сейчас - получите только 70% от стоимости (30% + весь профит сгорят)',
    
    // Tasks Screen
    tasksTitle: 'Задачи',
    availableTasks: 'Доступные задачи',
    completedTasks: 'Выполненные задачи',
    subscribeToChannel: 'Подпишись на канал TreasureTon',
    subscribeBonus: 'Бонус: -15% времени открытия сундука на 24 часа',
    subscribeBonusShort: 'На 24 часа - 15% времени открытия',
    dailyCheckIn: 'Ежедневная отметка',
    dailyCheckInDesc: 'Отмечайся каждый день и получай награды!',
    currentStreak: 'Текущая серия',
    daysStreak: 'дней',
    checkInButton: 'Отметиться',
    alreadyCheckedIn: 'Уже отмечен сегодня',
    reward7Days: '7 дней отметки подряд = 1 открытие на 35% быстрее',
    bonusChests: 'Бонусных сундуков',
    streakReward: '🎉 7 дней подряд! Следующий сундук откроется на 35% быстрее!',
    openChannel: 'Подписаться',
    checkSubscription: 'Проверить подписку',
    taskCompleted: 'Задача выполнена!',
    subscribeFirst: 'Сначала подпишись',
    bonusActive: '🎉 Бонус активен!',
    bonusExpires: 'Истекает через:',
    
    processing: 'Обработка...',
    error: 'Ошибка',
    success: 'Успешно',
  },
  
  en: {
    // Header
    appName: '🏰 TON Farm',
    
    // Treasures Screen
    treasureTrials: 'Treasure Trials',
    faqButton: '❓ FAQ',
    treasureDescription: 'Start small. Progress through the treasures to claim more profit!',
    canBuyTab: 'Available',
    activeTab: 'Active',
    buyChestButton: 'Buy chest',
    noActiveChests: 'Buy a chest!',
    chestOpening: '⏳ Chest opening...',
    rewardReady: '✨ Reward ready! Claim it now!',
    claimWindowExpires: '⚠️ Claim window expires in:',
    afterExpiryReturn: 'After expiry only 70% of cost will be returned',
    rewardOnClaim: 'Reward on claim:',
    claimRewardButton: '🎁 Claim reward',
    waitingForOpening: '⏳ Waiting for opening...',
    readyToClaim: '✅ Ready to claim!',
    
    // Treasure card labels
    cost: 'Cost',
    payout: 'Payout',
    cycle: 'Cycle',
    allTimeProfit: 'All time profit',
    
    // Chest unlock messages
    chestLocked: '🔒 Locked',
    unlockCondition: 'Claim the previous chest to unlock',
    unlockProgress: 'Unlock progress',
    claimsRemaining: 'Claim the previous chest reward',
    claimsRemainingFrom: 'Claim reward from', // "Claim reward from Bronze Treasure"
    times: 'more times',
    comingSoonChests: 'NEW CHESTS\nCOMING SOON',
    
    // Rules
    rulesButton: '📖 Rules',
    rulesTitle: '📖 Game Rules',
    rulesHowItWorks: '🎁 How chests work?',
    rulesHowItWorksText: '1. Buy a chest for TON\n2. Wait for opening (time depends on chest)\n3. Claim reward within 8 hours\n4. Get TON + profit!',
    rulesUnlocking: '🔓 Unlocking chests',
    rulesUnlockingText: 'Unlock conditions are shown on each chest card. Unlock progress is shown on the card.',
    rulesBurning: '🔥 BURNING MECHANIC',
    rulesBurningText: 'After chest opens you have 8 HOURS to claim reward!\n\n⚠️ If you miss it:\n• You get only 70% of chest cost\n• 30% of cost + ALL PROFIT burn forever\n\n✅ Claim on time - get 100% (cost + profit)!',
    rulesImportant: '⚡ Important to know',
    rulesImportantText: '• Opening time can be reduced with bonuses\n• Watch the expiry timer\n• Rewards are credited instantly',
    rulesClose: 'Close',
    
    // FAQ
    faqTitle: '❓ FAQ',
    faqAccountRules: '📛 Account Rules',
    faqAccountText: 'Creating or using multiple accounts is strictly prohibited.\nPlayer honesty is very important to us. Any manipulation attempts will result in permanent ban without recovery.',
    faqWithdrawal: '💸 Withdrawals',
    faqWithdrawalText: 'Withdrawal available 24 hours after deposit.\nAll TON withdrawals are processed within 24 hours.\nUsually faster, but up to one day is allowed.',
    faqDisclaimer: '🎮 Game Disclaimer',
    faqDisclaimerText: 'This is a game. All contributions are voluntary donations.\nWe do not provide financial or investment services.',
    faqClose: 'Close',
    
    // Balance Screen
    balanceTitle: '💰 Balance',
    supportButton: 'Support',
    availableBalance: 'Available',
    depositButton: '💳 Deposit',
    withdrawButton: '💸 Withdraw',
    transactionHistory: '📜 Transaction History',
    noTransactions: 'No transactions yet',
    deposit: 'Deposit',
    withdrawal: 'Withdrawal',
    referralBonus: 'Referral Bonus',
    claimReward: 'Reward',
    depositTitle: '💳 Deposit',
    depositDescription: 'Deposit via TON Connect',
    depositAmount: 'Deposit Amount',
    minDeposit: 'Minimum 0.5 TON',
    connectWallet: 'Connect Wallet',
    confirmDeposit: 'Confirm Deposit',
    depositSuccess: 'Deposit request sent! Awaiting confirmation.',
    withdrawTitle: '💸 Withdrawal',
    withdrawDescription: 'Withdraw your earned TON to your wallet',
    withdrawAmount: 'Withdrawal Amount',
    minWithdraw: 'Minimum 1 TON',
    walletAddress: 'TON Wallet Address',
    withdrawFee: 'Fee',
    youReceive: 'You will receive',
    confirmWithdraw: 'Confirm Withdrawal',
    withdrawSuccess: 'Withdrawal request created!',
    disconnectWallet: 'Disconnect Wallet',
    myWallet: 'My Wallet',
    status: 'Status',
    pending: 'Pending',
    completed: 'Completed',
    rejected: 'Rejected',
    date: 'Date',
    
    // Friends Screen
    ambassadorProgram: '👑 Ambassador Program',
    ambassadorText: 'Have a channel with an active audience? Become our ambassador and get exclusive bonuses.',
    becomePartner: '🌟 Become a Partner',
    inviteFriends: '👥 Invite Friends',
    yourReferralLink: 'Your referral link:',
    copyButton: '📋 Copy',
    copiedButton: '✅ Copied!',
    shareButton: '📤 Share',
    yourStats: '📊 Your Statistics',
    totalReferrals: 'Total Referrals',
    totalEarned: 'Total Earned',
    byLevels: '📈 By Levels',
    level: 'Level',
    referralsCount: 'Referrals:',
    earned: 'Earned:',
    yourReferrals: '👤 Your Referrals',
    referralsLabel: 'Referrals:',
    deposits: 'Bought:',
    earnedLabel: 'Earned:',
    noReferrals: 'You have no referrals yet',
    noReferralsText: 'Share your link with friends and start earning!',
    howItWorks: '💡 How it works?',
    level1: 'Level 1 - 7%',
    level1Text: 'Get 7% from each balance top-up by your direct referrals',
    level2: 'Level 2 - 4%',
    level2Text: 'Get 4% from balance top-ups by your referrals\' referrals',
    level3: 'Level 3 - 2%',
    level3Text: 'Get 2% from balance top-ups by level 3 referrals',
    bonusInfo: '💰 All bonuses are credited automatically to your balance!',
    
    // Bottom Nav
    treasures: 'Chests',
    balance: 'Balance',
    friends: 'Friends',
    games: 'Games',
    admin: 'Admin',
    
    // Games Screen
    gamesTitle: '🎮 Games',
    comingSoon: 'Coming soon...',
    chooseGame: 'Choose a game and try your luck!',
    game1to100: '1 to 100',
    game1to100Desc: 'Guess where the number from 1 to 100 will land. Simple and fast game!',
    gameMines: 'MINES',
    gameMinesDesc: 'Open cells and avoid mines. Cash out whenever you want!',
    minBet: 'Min. bet',
    houseEdge: 'House edge',
    gamesInfo: 'ℹ️ Information',
    gamesInfoFair: 'All games with fair result generation',
    gamesInfoInstant: 'Winnings are credited instantly',
    gamesInfoMinBet: 'Minimum bet: 0.1 TON',
    gamesInfoHouseEdge: 'House edge: 2% (fee from each bet)',
    gamesInfoDailyLimit: 'Limit: 10 games per day',
    
    // Dice Game
    diceGuessNumber: 'Guess where the number will land',
    diceBetAmount: 'Bet Amount (TON)',
    diceChooseType: 'Choose type',
    diceTargetNumber: 'Target number',
    diceMultiplier: 'Multiplier',
    diceWinChance: 'Win Chance',
    diceRolling: 'Rolling...',
    diceRoll: 'ROLL',
    diceWin: 'WIN!',
    diceLoss: 'LOSS',
    diceResult: 'Result',
    diceTarget: 'Target',
    diceHowToPlay: 'How to play?',
    diceStep1: 'Choose bet type: UNDER (less) or OVER (more)',
    diceStep2: 'Set target number from 2 to 98',
    diceStep3: 'Enter bet amount',
    diceStep4: 'If the number matches your prediction - you win!',
    diceStep5: 'Lower chance - higher multiplier',
    minBetError: 'Minimum bet 0.1 TON',
    maxBetError: 'Maximum bet 10 TON',
    insufficientFunds: 'Insufficient funds',
    gameError: 'Game error',
    
    // Mines Game
    minesBetAmount: 'Bet Amount (TON)',
    minesCount: 'Mines count',
    minesStartGame: 'Start Game',
    minesCashout: 'Cash Out',
    minesMultiplier: 'Multiplier',
    minesPotentialWin: 'Potential Win',
    minesWin: 'WIN!',
    minesExplosion: 'BOOM!',
    minesHowToPlay: 'How to play?',
    minesStep1: 'Choose mines count (7, 10 or 15)',
    minesStep2: 'Place bet and start game',
    minesStep3: 'Reveal safe tiles',
    minesStep4: 'Each safe tile increases multiplier',
    minesStep5: 'Cash out anytime or continue',
    minesRisk: 'More mines - higher risk, but huge wins!',
    createGameError: 'Error creating game',
    revealError: 'Error revealing tile',
    cashoutError: 'Error cashing out',
    
    // Admin Screen
    adminPanel: '🔧 Admin Panel',
    statistics: '📊 Statistics',
    withdrawals: '💸 Withdrawals',
    depositsTab: '💵 Deposits',
    totalUsers: 'Total Users',
    totalDeposits: 'Total Deposits',
    totalWithdrawals: 'Total Withdrawals',
    totalReferralBonuses: 'Total Ref. Bonuses',
    pendingWithdrawals: 'Pending Withdrawals',
    noPendingWithdrawals: 'No pending withdrawals',
    user: 'User',
    amount: 'Amount',
    fee: 'Fee',
    toReceive: 'To Receive',
    wallet: 'Wallet',
    created: 'Created',
    approve: 'Approve',
    reject: 'Reject',
    pendingDeposits: 'Pending Deposits',
    noPendingDeposits: 'No pending deposits',
    userWallet: 'User Wallet',
    
    // Stake Screen
    stakeTitle: '💎 Stake',
    stakeDescription: 'Earn 2% daily for 50 days. ⚠️ Claim on time - or get only 70% of daily profit!',
    stakeLockedMessage: 'Available after unlocking Silver Treasure',
    activeStake: '🔒 Active Stake',
    stakeUnlocked: '🎉 Stake Unlocked!',
    stakedAmount: 'Staked Amount:',
    dailyRate: 'Daily Rate:',
    daysRemaining: 'Days Remaining:',
    pendingRewards: 'Pending Rewards:',
    claimButton: 'Claim Rewards',
    claimAvailableIn: 'Claim available in:',
    hours: 'h',
    days: 'days',
    canClaimOncePerDay: 'You can claim once per day',
    principalReturned: '💰 Your principal will be returned when you claim rewards!',
    createNewStake: 'Create New Stake',
    orIncreaseStake: 'or increase current stake',
    amountLabel: 'Amount (TON)',
    minimumStake: 'Minimum: 0.7 TON',
    lockPeriod: 'Lock period: 50 days',
    dailyReturn: 'Daily return: 2%',
    totalReturn: 'Total return: deposit + 100% profit',
    claimAnytime: 'Claim rewards every day!',
    createStakeButton: 'Create Stake',
    increaseStakeButton: 'Increase Stake',
    stakeCreated: 'Stake created successfully!',
    stakeIncreased: 'Stake increased successfully!',
    howItWorksStake: 'ℹ️ How it works',
    howItWorksText1: '1. Lock your TON for 50 days',
    howItWorksText2: '2. Earn 2% daily',
    howItWorksText3: '3. Claim rewards every day',
    howItWorksText4: '4. Get your principal back after 50 days',
    howItWorksText5: '⚠️ BURNING MECHANIC FOR STAKE: If you don\'t claim daily reward on time, only 70% of daily profit will be automatically credited (30% burns)',
    burnWarningTitle: 'WARNING! BURNING!',
    burnWarningText: 'Little time left before burning!',
    burnWarningInfo: 'If you don\'t claim now - you\'ll get only 70% of cost (30% + all profit will burn)',
    
    // Tasks Screen
    tasksTitle: 'Tasks',
    availableTasks: 'Available Tasks',
    completedTasks: 'Completed Tasks',
    subscribeToChannel: 'Subscribe to TreasureTon channel',
    subscribeBonus: 'Bonus: -15% chest opening time for 24 hours',
    subscribeBonusShort: 'For 24 hours - 15% opening time',
    dailyCheckIn: 'Daily Check-In',
    dailyCheckInDesc: 'Check in every day and get rewards!',
    currentStreak: 'Current Streak',
    daysStreak: 'days',
    checkInButton: 'Check In',
    alreadyCheckedIn: 'Already checked in today',
    reward7Days: '7 days check-in streak = 1 opening 35% faster',
    bonusChests: 'Bonus chests',
    streakReward: '🎉 7 days streak! Next chest opens 35% faster!',
    openChannel: 'Subscribe',
    checkSubscription: 'Check Subscription',
    taskCompleted: 'Task completed!',
    subscribeFirst: 'Please subscribe first',
    bonusActive: '🎉 Bonus active!',
    bonusExpires: 'Expires in:',
    processing: 'Processing...',
    error: 'Error',
    success: 'Success',
  }
};

export const getTranslation = (lang: Language) => translations[lang];

